import { Redirect, Route, useRouteMatch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import ParentWrapper from "../../components/ParentWrapper";
import PrivateRoute from "../../components/PrivateRoute";
import ApproveRejectPage from "../SampleDistribution/ApproveReject";
import BioSpecimenAccessProgram from "../SampleDistribution/ShipmentInquiries";
import ShipmentRequests from "../SampleDistribution/ShipmentRequests";
import NewShipmentRequest from "../SampleDistribution/NewShipmentRequest";
const queryClient = new QueryClient();

const ParentConsole = () => {
  let { path } = useRouteMatch();
  return (
    <QueryClientProvider client={queryClient}>
      <ParentWrapper path={path}>
        <PrivateRoute exact path={`${path}/shipment-inquiries`}>
          <BioSpecimenAccessProgram />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/shipment_request`}>
          <ShipmentRequests />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/new-shipment-request`}>
          <NewShipmentRequest />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/approve-reject`}>
          <ApproveRejectPage />
        </PrivateRoute>
        <Route>
          <Redirect to={`${path}/shipment-inquiries`} />
        </Route>
      </ParentWrapper>
    </QueryClientProvider>
  );
};

export default ParentConsole;
